export default async function getBackupsDirHandle () {
           // Get handle to draft file in OPFS
           const root = await navigator.storage.getDirectory();        
           const backupsDirHandle = await root.getDirectoryHandle('backups', { create: true });
           return backupsDirHandle
}